module.exports = __webpack_public_path__ + "img/girl.fb7492f8.png";